module.exports = __webpack_public_path__ + "static/media/education-object-0-2-0.ef09eee4.png";